
import React, { useEffect, useState } from 'react';
import { Button, message } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import AlertTable from '../../components/admin/AlertTable';
import { validationService, ValidationAlert } from '../../services/validation';
import CommonCard from '../../components/CommonCard';

const ValidationPage: React.FC = () => {
    const [alerts, setAlerts] = useState<ValidationAlert[]>([]);
    const [loading, setLoading] = useState(false);

    const fetchAlerts = async () => {
        setLoading(true);
        try {
            // Get all alerts (both resolved and unresolved)
            const data = await validationService.getAlerts();
            // Sort by unresolved first, then by date (newest first)
            const sortedData = data.sort((a, b) => {
                if (a.is_resolved === b.is_resolved) {
                    return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
                }
                return a.is_resolved ? 1 : -1;
            });
            setAlerts(sortedData);
        } catch (error) {
            console.error('Failed to fetch alerts:', error);
            message.error('加载告警数据失败，请检查登录状态');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAlerts();
    }, []);

    const handleResolve = async (id: number) => {
        try {
            await validationService.resolveAlert(id);
            message.success('告警已标记为解决');
            fetchAlerts(); // Refresh list
        } catch (error) {
            console.error('Failed to resolve alert:', error);
            message.error('处理失败，请稍后重试');
        }
    };

    return (
        <div style={{ padding: '24px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
                <div>
                    <h1 style={{ margin: 0, fontSize: '24px', fontWeight: 600, color: '#1f1f1f' }}>数据验证与异常处理</h1>
                    <p style={{ margin: '4px 0 0', color: '#8c8c8c' }}>管理和处理系统自动检测到的数据异常。</p>
                </div>
                <Button
                    type="primary"
                    icon={<ReloadOutlined />}
                    onClick={fetchAlerts}
                    loading={loading}
                    style={{ height: 40, borderRadius: 6 }}
                >
                    刷新列表
                </Button>
            </div>

            <CommonCard title="异常告警列表" noPadding>
                <div style={{ padding: '0 24px 24px' }}>
                    <AlertTable
                        alerts={alerts}
                        loading={loading}
                        onResolve={handleResolve}
                    />
                </div>
            </CommonCard>
        </div>
    );
};

export default ValidationPage;
